import { FC } from 'react';
import { createBrowserHistory } from 'history';
import { RedirectPage } from 'components/RedirectPage';

export const history = createBrowserHistory();

const App: FC = () => <RedirectPage />;

export default App;
